interface Audio {
  play: () => void
  pause: () => void
  isPlaying: boolean
  duration: number
  position: number
  AudioPlayer?: React.JSX.Element | null
}

export class AudioAdapter {
  useAudio: (_: string) => Audio

  constructor(methods: AudioAdapter) {
    this.useAudio = methods.useAudio
  }
}
